import sessionReader from '../store/readHelpers/SessionReader';
import marketplacePropertiesService from './MarketplacePropertiesService';

const wordCountService = {
    /**
     * Decide whether or not the word count should be shown tatking into account the show-word-count setting in the interaction as well as
     * the mpp that forces showing of word count for admins.
     * @param {boolean} showWordCount: showWordCount member value from the model object, or other relevant flag specific to context
     * @returns {boolean}
     */
    shouldShowWordCount(showWordCount = false) {
        if (showWordCount) {
            // Never hide word count if the input (model) or other flag says it should be shown
            return true;
        }

        const showWordCountContext = sessionReader.isContextViewDelivery()
            || sessionReader.isContextViewGradingQuestionDelivery();

        // Always show word count in "view delivery" contexts if the marking word count MPP is enabled.
        return (showWordCountContext && marketplacePropertiesService.isMarkingWordCountEnabled());
    },
};

export default wordCountService;
